export const tipos = {
    "SEARCH": "BÚSQUEDA CLIENTE",
    "CONTINUE_BOOKING": "BOTÓN IR A LA RESERVA",
    "FINAL_BOOKING_FORM": "FORMULARIO FINAL DE RESERVA",
    "OPEN_VEHICLE": "ABRIR DETALLE VEHÍCULO"
  }